export default __webpack_public_path__ + "static/media/img5.338e0056.png";